import { render } from "./TemplateSettingsIndex.vue?vue&type=template&id=8b7eb24e"
import script from "./TemplateSettingsIndex.vue?vue&type=script&lang=js"
export * from "./TemplateSettingsIndex.vue?vue&type=script&lang=js"

import "./TemplateSettingsIndex.vue?vue&type=style&index=0&id=8b7eb24e&lang=scss"

import exportComponent from "/Users/niteshdas/Projects/wordpress/wp-content/plugins/easy-restaurant-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__